import React from "react";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Menu, Transition } from '@headlessui/react';
import { TiBusinessCard, TiChartLineOutline } from "react-icons/ti";

class Nav extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      options: [
        null,
      ],
    }
  }
  findNavIcon = (icon) => {
    if (icon === 'OP') {
      return (
        <svg width="28" height="34" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M26 0H0V32.7929C0 33.2383 0.53857 33.4614 0.853554 33.1465L6 28H26C27.1046 28 28 27.1046 28 26V2C28 0.895432 27.1046 0 26 0ZM6 28V6H16C19.3137 6 22 8.68629 22 12V16C22 19.3137 19.3137 22 16 22H12L6 28Z" fill="white"/>
        </svg>
      )
    } else if (icon === 'PV') {
      return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.10557 7.44719C0.428004 7.78597 0 8.4785 0 9.23605V23.191C0 23.5627 0.391156 23.8044 0.723607 23.6382L3.73333 22.1333L4.80086 13.5931C4.92527 12.5978 5.53889 11.7305 6.43605 11.282L16 6.49998V0.808995C16 0.437304 15.6088 0.195556 15.2764 0.361781L1.10557 7.44719Z" fill="white"/>
          <path d="M9.10557 11.4472C8.428 11.786 8 12.4785 8 13.2361V27.191C8 27.5627 8.39116 27.8044 8.72361 27.6382L11.7333 26.1333L12.8009 17.5932C12.9253 16.5978 13.5389 15.7306 14.436 15.282L24 10.5V4.80902C24 4.43733 23.6088 4.19558 23.2764 4.3618L9.10557 11.4472Z" fill="white"/>
          <path d="M16 17.2361C16 16.4785 16.428 15.786 17.1056 15.4472L31.2764 8.3618C31.6088 8.19558 32 8.43733 32 8.80902V22.7639C32 23.5215 31.572 24.214 30.8944 24.5528L16.7236 31.6382C16.3912 31.8044 16 31.5627 16 31.191V17.2361Z" fill="white"/>
        </svg>
      )
    } else if (icon === 'SP') {
      return (
        <svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.3083 5.405C17.1683 5.635 17.0233 5.805 16.8733 5.915C16.7333 6.015 16.5483 6.065 16.3183 6.065C16.0983 6.065 15.8583 5.99 15.5983 5.84C15.3483 5.68 15.0533 5.51 14.7133 5.33C14.3733 5.15 13.9833 4.985 13.5433 4.835C13.1033 4.675 12.5883 4.595 11.9983 4.595C10.9583 4.595 10.1783 4.83 9.65829 5.3C9.13829 5.76 8.87829 6.365 8.87829 7.115C8.87829 7.595 9.01829 7.995 9.29829 8.315C9.58829 8.625 9.96329 8.895 10.4233 9.125C10.8933 9.355 11.4233 9.56 12.0133 9.74C12.6033 9.92 13.2083 10.12 13.8283 10.34C14.4483 10.55 15.0533 10.8 15.6433 11.09C16.2333 11.38 16.7583 11.745 17.2183 12.185C17.6883 12.625 18.0633 13.165 18.3433 13.805C18.6333 14.435 18.7783 15.205 18.7783 16.115C18.7783 17.105 18.6033 18.035 18.2533 18.905C17.9133 19.765 17.4183 20.52 16.7683 21.17C16.1183 21.81 15.3133 22.315 14.3533 22.685C13.4033 23.055 12.3233 23.24 11.1133 23.24C10.4233 23.24 9.73329 23.17 9.04329 23.03C8.36329 22.89 7.70329 22.695 7.06329 22.445C6.43329 22.195 5.83829 21.895 5.27829 21.545C4.71829 21.195 4.22829 20.805 3.80829 20.375L5.12829 18.245C5.23829 18.085 5.38329 17.955 5.56329 17.855C5.74329 17.745 5.93329 17.69 6.13329 17.69C6.40329 17.69 6.68829 17.79 6.98829 17.99C7.28829 18.19 7.63329 18.41 8.02329 18.65C8.41329 18.89 8.86329 19.11 9.37329 19.31C9.89329 19.51 10.5133 19.61 11.2333 19.61C12.2833 19.61 13.0933 19.37 13.6633 18.89C14.2433 18.41 14.5333 17.695 14.5333 16.745C14.5333 16.195 14.3883 15.75 14.0983 15.41C13.8183 15.07 13.4483 14.785 12.9883 14.555C12.5283 14.325 12.0033 14.13 11.4133 13.97C10.8233 13.8 10.2183 13.615 9.59829 13.415C8.97829 13.215 8.37329 12.975 7.78329 12.695C7.19329 12.415 6.66829 12.045 6.20829 11.585C5.74829 11.125 5.37329 10.555 5.08329 9.875C4.80329 9.195 4.66329 8.35 4.66329 7.34C4.66329 6.53 4.82329 5.745 5.14329 4.985C5.46329 4.225 5.93329 3.55 6.55329 2.96C7.17329 2.37 7.93329 1.895 8.83329 1.535C9.74329 1.175 10.7833 0.994995 11.9533 0.994995C13.2633 0.994995 14.4733 1.2 15.5833 1.61C16.7033 2.01 17.6483 2.57 18.4183 3.29L17.3083 5.405Z" fill="white"/>
          <rect y="26" width="24" height="4" fill="white"/>
        </svg>
      )
    } else if (icon === 'IP') {
      return (
        <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.704 0V18.096H0V0H4.704Z" fill="white"/>
          <path d="M13.1884 8.304H14.7484C16.4764 8.304 17.3404 7.552 17.3404 6.048C17.3404 4.544 16.4764 3.792 14.7484 3.792H13.1884V8.304ZM13.1884 18.096H8.48438V0H15.9724C18.0044 0 19.5564 0.528 20.6284 1.584C21.7164 2.64 22.2604 4.128 22.2604 6.048C22.2604 7.968 21.7164 9.456 20.6284 10.512C19.5564 11.568 18.0044 12.096 15.9724 12.096H13.1884V18.096Z" fill="white"/>
        </svg>
      )
    } else if (icon === 'GR') {
      return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M32 0H0V7.30291C0.495721 7.02081 1.02905 6.73872 1.6 6.43673C2.10402 6.17014 2.63736 5.88805 3.2 5.57676C10.6667 1.72614 12.9333 1.72614 13.3333 1.85892C13.5111 1.94744 13.5704 2.03596 13.6296 2.12448C13.6593 2.16874 13.6889 2.213 13.7333 2.25726L14.9333 4.51452C14.9333 4.51452 15.8667 3.9834 16 3.85062C16.0824 3.80959 16.1648 3.7432 16.2787 3.65145C16.5333 3.4463 16.9454 3.11435 17.8667 2.6556C21.6 0.796681 25.6 2.78838 28.5333 8.36515C31.3333 13.9419 29.7333 18.1909 27.4667 19.5187C26.7576 19.9894 25.3154 20.4601 24.4396 20.746L24.4394 20.7461C24.3271 20.7827 24.2242 20.8163 24.1333 20.8465C23.5131 21.0524 23.6142 21.4178 23.6909 21.6955C23.7131 21.7759 23.7333 21.849 23.7333 21.9087C23.8667 22.1743 24.5333 23.6349 24.5333 24.2988C24.4 26.2905 19.7333 29.4772 15.8667 31.4689C15.6667 31.5353 15.5 31.6349 15.3333 31.7344C15.1667 31.834 15 31.9336 14.8 32H32V0ZM22.9334 18.1908C22.5334 18.058 22.0001 17.7925 22.0001 17.7925L16.8001 8.09951C16.8001 8.03312 16.8334 7.93354 16.8668 7.83395L16.8668 7.83393C16.9001 7.73435 16.9334 7.63478 16.9334 7.56839C17.0668 7.43561 17.2001 7.17005 17.2001 6.90449C17.2001 6.63893 17.3334 5.04557 18.9334 4.24889C22.5334 2.52275 25.7334 6.63893 26.9334 9.29453C28.0001 11.2862 29.3334 16.5974 25.7334 18.4564C25.1922 18.7797 24.7389 18.7531 24.3734 18.7316L24.3734 18.7316C24.2887 18.7266 24.2087 18.7219 24.1334 18.7219C23.8668 18.7219 23.7334 18.7219 23.3334 18.4564C23.2668 18.39 23.2001 18.3568 23.1334 18.3236C23.0668 18.2904 23.0001 18.2572 22.9334 18.1908ZM0 31.8671V22.8381C2.13333 26.9543 4.26667 30.9377 4.8 31.8671H0ZM3.6 5.97521C7.73333 3.85073 12.4 2.12459 12.8 2.78849C13.2 3.71795 8.26667 7.03745 4.93333 8.76359C3.46667 9.56027 1.6 10.357 0 11.0209V8.09969C0.84634 7.46757 1.86056 6.91904 2.84286 6.38778C3.09858 6.24947 3.35213 6.11234 3.6 5.97521Z" fill="white"/>
        </svg>
      )
    }
  }
  render() {
    return (
      <Droppable droppableId="navOptions">
        {(provided, snapshot) => (
          <div className="h-screen hidden sticky top-0 lg:block shadow-lg relative lg:w-75 md:w-70">
            <div className="bg-gray-800 h-full rounded-2xl dark:bg-gray-800">
              <div className="flex items-center justify-center pt-6">
                {this.findNavIcon(this.props.icon)}
                
                
              </div>
              {this.props.icon === 'OP' && this.props.showPageLinks && (
                <div className="px-4 mt-6 space-y-2 border-b border-gray-600 pb-4">
                  <Link
                    to="/openprint"
                    className={`block px-3 py-2 text-sm rounded ${
                      this.props.activePage === 'dashboard'
                        ? 'bg-gray-700 text-white'
                        : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                    }`}
                  >
                    Dashboard
                  </Link>
                  <Link
                    to="/openprint/orders"
                    className={`block px-3 py-2 text-sm rounded ${
                      this.props.activePage === 'total-late-orders'
                        ? 'bg-gray-700 text-white'
                        : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                    }`}
                  >
                    Total Late Orders
                  </Link>
                  <Link
                    to="/openprint/orders/today"
                    className={`block px-3 py-2 text-sm rounded ${
                      this.props.activePage === 'todays-orders'
                        ? 'bg-gray-700 text-white'
                        : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                    }`}
                  >
                    Today's Orders
                  </Link>
                  <Link
                    to="/openprint/orders/errors"
                    className={`block px-3 py-2 text-sm rounded ${
                      this.props.activePage === 'shipping-errors'
                        ? 'bg-gray-700 text-white'
                        : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                    }`}
                  >
                    Shipping Errors
                  </Link>
                </div>
              )}
              <nav className="mt-6" {...provided.droppableProps} ref={provided.innerRef}>
                <div>
                  {this.props.navOptions.map( (component_info, index) => {
                    return (
                      <Draggable key={component_info.id} draggableId={component_info.id} index={index}>
                        {(provided, snapshot) => (
                          <div className="w-full font-thin text-white flex items-center p-4 my-2 transition-colors duration-200 justify-start bg-gradient-to-r border-r-4 border-blue-500 dark:from-gray-700 dark:to-gray-800 border-r-4 border-blue-500" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <span className="text-left">
                              {component_info.size == 8 ? <TiChartLineOutline /> : <TiBusinessCard />}
                            </span>
                            <span className="mx-4 text-sm font-normal" >
                              {component_info.name}
                            </span>
                          </div>
                          
                        )}
                      </Draggable>
                    )
                  })}
                  {provided.placeholder}
                </div>
              </nav>
            </div>
          </div>
        )}
      </Droppable>
    )
  }
}

export default Nav;
